import React from "react";
import moment from "moment";
import CardClass from "../../CardClass";
import MUIBox from "@mui/material/Box";
import MUIPaper from "@mui/material/Paper";
import MUITable from "@mui/material/Table";
import MUITableBody from "@mui/material/TableBody";
import MUITableCell from "@mui/material/TableCell";
import MUITableContainer from "@mui/material/TableContainer";
import MUITableRow from "@mui/material/TableRow";
import MUITableHead from "@mui/material/TableHead";
import EmptyState from "../../EmptyState";

export default class CardApprovalSummaryApprovalNotes extends CardClass {
    componentDidUpdate(prevProps) {
        if (prevProps.orderActivityNotes !== this.props.orderActivityNotes) {
            this.setState({
                approvalNotes: this.props.orderActivityNotes.filter(note => note.noteTypeTermId === 88),
            });
        }
    }

    /**
     * Render the content of the card.
     */
    renderContent() {
        if (this.state.approvalNotes && this.state.approvalNotes.length > 0) {
            this.state.approvalNotes.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            return (
                <MUIBox sx={{ mt: 3 }}>
                    <MUITableContainer component={MUIPaper} elevation={0} sx={{ maxHeight: 300 }}>
                        <MUITable stickyHeader size="small">
                            <MUITableHead>
                                <MUITableRow>
                                    <MUITableCell sx={{ width: '200px', whiteSpace: 'nowrap' }}>Created By</MUITableCell>
                                    <MUITableCell>Note</MUITableCell>
                                </MUITableRow>
                            </MUITableHead>
                            <MUITableBody>
                                {this.state.approvalNotes.map((note, index) => (
                                    <MUITableRow key={index}>
                                        <MUITableCell sx={{ width: '200px', whiteSpace: 'nowrap' }}>
                                            {moment.utc(note.createdAt).local().format("M/D/YYYY h:mma")}
                                            <br />
                                            {`${note.createdBy.firstname} ${note.createdBy.lastname}`}
                                        </MUITableCell>
                                        <MUITableCell>{note.text}</MUITableCell>
                                    </MUITableRow>
                                ))}
                            </MUITableBody>
                        </MUITable>
                    </MUITableContainer>
                </MUIBox>
            );
        }
        return (
            <EmptyState
                line1="No Approval Notes"
            />
        )
    };


    /**
     * @returns {string} The title of the card.
     */
    getTitle() {
        return "Notes";
    }
}